import React, { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import { Form, FormFields, Stack, FormTextField, FormActions, FormNumberTextField } from "sprint-common-web";

import { MovieContentSubtype } from "../../../../../common/types/MovieContentSubtype";
import { EditMovieInfoFormInputs } from "./EditMovieInfoFormInputs";
import { useEditMovieInfoForm } from "./useEditMovieInfoForm";

export interface EditMovieInfoFormProps {
    contentType: MovieContentSubtype;
    onCancel(): void;
    onSubmited(): void;
}

export const EditMovieInfoForm: FunctionComponent<EditMovieInfoFormProps> = (props: EditMovieInfoFormProps) => {
    const { contentType, onCancel, onSubmited } = props;
    const { defaultInputs, updateMovie, validateTitle } = useEditMovieInfoForm(contentType);

    const { errors, control, formState, reset, handleSubmit } = useForm<EditMovieInfoFormInputs>({
        defaultValues: defaultInputs,
        criteriaMode: "all"
    });

    const clearAndCallOnClose = () => {
        reset();
        onCancel();
    };

    const submit = async (inputs: EditMovieInfoFormInputs) => {
        await updateMovie(inputs);
        onSubmited();
    };

    return (
        <Form onSubmit={handleSubmit(submit)}>
            <FormFields>
                <Stack>
                    <FormTextField
                        label="Title"
                        name="title"
                        control={control}
                        errors={errors}
                        rules={{ required: "Please enter film title", validate: validateTitle }}
                    />
                    <FormNumberTextField
                        label="Year"
                        name="year"
                        control={control}
                        errors={errors}
                        rules={{ required: "Please enter year" }}
                    />
                </Stack>
            </FormFields>
            <FormActions isLoading={formState.isSubmitting || formState.isValidating} onCancel={clearAndCallOnClose} />
        </Form>
    );
};
